import React, { useRef, useState, useEffect } from 'react';
import css from './BasicDropdown.module.css';
const BasicDropdown = props => {
  const {
    triggerButton,
    menuContent,
    arch,
    onShowChange = undefined,
    hideOnScroll,
    wrapperClassName,
    contentClassName,
  } = props;
  const wrapperRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [ignoreScroll, setIgnoreScroll] = useState(false);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (hideOnScroll && !ignoreScroll) {
      document.addEventListener('scroll', handleScroll);
    } else {
      document.removeEventListener('scroll', handleScroll);
    }

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };

    function handleScroll() {
      if (!ignoreScroll) {
        setShowMenu(false);
      }
    }
  }, [ignoreScroll]);

  useEffect(() => {
    if (onShowChange) onShowChange(showMenu);
  }, [showMenu]);

  const handleClick = () => {
    if (hideOnScroll) {
      if (document.documentElement.scrollTop > 0) {
        setIgnoreScroll(true);
        // window.scrollTo({ top: 0 })
        setIgnoreScroll(false);
      }
    }

    setShowMenu(true);
  };

  return (
    <div className={wrapperClassName || css.wrapper}>
      <div
        className={contentClassName || css.contentWrapper}
        onClick={handleClick}
        ref={wrapperRef}
      >
        {triggerButton}
        {showMenu && <div className={arch ? css.archMenu : css.menu}>{menuContent}</div>}
      </div>
    </div>
  );
};

export default BasicDropdown;
